module.exports = __webpack_public_path__ + "static/CircularPro-BoldItalic.f0b60c19.woff";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-BoldItalic.woff
// module id = 722
// module chunks = 168707334958949